import React from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import { PrimaryButton } from "../../common_components/Buttons";


function DownloadButtonRow(props) {
    return (
        <div className="download-button-row">
            <div className="download-button-row-title">
                {props.title}
            </div>
            <div className="download-button-and-loader">
                <PrimaryButton onClick={props.onClick} text="Download" buttonClasses="w-108" submitLoading={props.loading} />
                {props.loading ?
                    <ClipLoader color="white" aria-label="Loading Spinner" size={20} />
                    : <div className="loader-space"></div>}
            </div>
        </div>
    )
}

export default DownloadButtonRow;